import { SxProps, Theme } from '@mui/system';

export const tableFooterStyles: SxProps<Theme> = {
  left: 0,
  bottom: 0,
  zIndex: 2,
  position: 'sticky',
  background: 'white',
};

export const tableContainerStyles: SxProps<Theme> = {
  maxHeight: 'calc(100vh - 200px)',
  overflowY: 'auto',
};
